export const mockDataBlock = {
  sessionTotal: "5,397",
  pageViewsTotal: "7,464",
  featuredOffer: "97.79%",
  unitsOrdered: "1,367",
  unitsSessionPercentage: "25.33%",
  orderedProductSales: "$40,906.36",
  totalOrderItems: "1,312",
};
